import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ChatJob } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  chatJob: ChatJob;
  submitMessage(request: Boundaries["submitMessage"]["request"]): void;
}

function useSubmitMessage(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isSubmitMessageRequestPending),
    isRequestSuccess: useSelector(selector.isSubmitMessageRequestSuccess),
    isRequestFailure: useSelector(selector.isSubmitMessageRequestFailure),
    chatJob: useSelector(selector.getChatJob),
    submitMessage: core.submitMessage,
  };
}

export { useSubmitMessage };
